"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ListItemBuilder = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _material = require("@mui/material");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const merge = require("deepmerge"),
  defaultListStyles = {
    alignItems: "flex-start",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start"
  },
  defaultListItemStyles = {
    flexBasis: "auto",
    display: "inline-block",
    padding: "0 1rem 0 0",
    width: "auto"
  },
  imageListArray = [{
    alt: "Find PHEAA on Facebook",
    src: `${process.env.PUBLIC_URL}/general/images/icons/facebook.svg`,
    url: "http://www.facebook.com/pheaa.aid"
  }, {
    alt: "Follow PHEAA on Twitter",
    src: `${process.env.PUBLIC_URL}/general/images/icons/twitter.svg`,
    url: "https://twitter.com/pheaaaid"
  }, {
    alt: "Follow PHEAA on LinkedIn",
    src: `${process.env.PUBLIC_URL}/general/images/icons/linkedin.svg`,
    url: "https://www.linkedin.com/company/pheaa"
  }, {
    alt: "Follow PHEAA on Instagram",
    src: `${process.env.PUBLIC_URL}/general/images/icons/instagram.svg`,
    url: "https://www.instagram.com/pheaaaid/"
  }, {
    alt: "Follow PHEAA on Youtube",
    src: `${process.env.PUBLIC_URL}/general/images/icons/youtube.svg`,
    url: "https://www.youtube.com/user/PHEAAStudentAid"
  }],
  ListItemBuilder = props => {
    const {
        item,
        sx = {},
        testId
      } = props,
      {
        alt,
        path,
        src,
        url
      } = item,
      listItemStyles = merge(defaultListItemStyles, sx);
    return /*#__PURE__*/_react.default.createElement(_material.ListItem, {
      "data-testid": testId,
      sx: listItemStyles
    }, path && /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
      "data-testid": testId ? `${testId}_router_link` : null,
      to: path
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: src,
      alt: alt,
      height: "30",
      width: "30"
    })), url && !path && /*#__PURE__*/_react.default.createElement(_material.Link, {
      href: url,
      target: "_blank",
      "data-testid": testId ? `${testId}_link` : null
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: src,
      alt: alt,
      height: "30",
      width: "30"
    })));
  };

/**
	 * Component to embed small social media icons in the footer
	 *
	 * @visibleName Social Media List
	 * @author [Jeff Stevens](mailto:jeffrey.stevens@pheaa.org)
	*/
exports.ListItemBuilder = ListItemBuilder;
const SocialMediaList = props => {
  const {
      listArray = imageListArray,
      listItemSx = {},
      sx = {},
      testId
    } = props,
    listStyles = merge(defaultListStyles, sx);
  return /*#__PURE__*/_react.default.createElement(_material.List, {
    className: "social-media-list",
    "data-testid": testId,
    sx: listStyles
  }, listArray.map((item, i) => /*#__PURE__*/_react.default.createElement(ListItemBuilder, {
    item: item,
    key: `socialMedia_${i}`,
    sx: listItemSx
  })));
};

// Define propTypes;
SocialMediaList.propTypes = {
  /** Array for each icon's attributes (Default Value: imageListArray) */
  listArray: _propTypes.default.arrayOf(_propTypes.default.shape({
    item: _propTypes.default.shape({
      /** Alt. Description of Image/Item */
      alt: _propTypes.default.string,
      /** Path to internal React path, if React Component */
      path: _propTypes.default.string,
      /** Path to image asset */
      src: _propTypes.default.string,
      /** Path to external location */
      url: _propTypes.default.string
    }),
    /** Custom styles object for item */
    sx: _propTypes.default.object,
    /** @ignore */
    testId: _propTypes.default.string
  })),
  /** Custom styles object for list (Default Value: {}) */
  listItemSx: _propTypes.default.object,
  /** Custom component styles object (Default Value: {}) */
  sx: _propTypes.default.object,
  /** @ignore */
  testId: _propTypes.default.string
};
ListItemBuilder.propTypes = {
  item: _propTypes.default.shape({
    alt: _propTypes.default.string.isRequired,
    path: _propTypes.default.string,
    src: _propTypes.default.string.isRequired,
    url: _propTypes.default.string
  }).isRequired,
  sx: _propTypes.default.object,
  testId: _propTypes.default.string
};

// Export component as default;
var _default = exports.default = SocialMediaList;